const wolrdLanguages: string[] = [
  'Albanian',
  'Arabic',
  'Armenian',
  'Azerbaijani',
  'Basque',
  'Belarusian',
  'Bengali',
  'Berber languages',
  'Bihari languages',
  'Bosnian',
  'Bulgarian',
  'Catalan',
  'Chinese',
  'Montenegrin',
  'Czech',
  'Danish',
  'Dutch',
  'English',
  'Estonian',
  'Finnish',
  'French',
  'Georgian',
  'German',
  'Irish',
  'Galician',
  'Greek Ancient',
  'Greek',
  'Gujarati',
  'Hebrew',
  'Hindi',
  'Croatian',
  'Hungarian',
  'Icelandic',
  'Italiano',
  'Javanese',
  'Japanese',
  'Kazakh',
  'Korean',
  'Kurdish',
  'Latin',
  'Latvian',
  'Limburgan, Limburger, Limburgish',
  'Lithuanian',
  'Macedonian',
  'Marathi',
  'Malay',
  'Maltese',
  'Norwegian',
  'Occitan',
  'Panjabi; Punjabi',
  'Persian',
  'Polish',
  'Portuguese',
  'Romany',
  'Romanian',
  'Russian',
  'Sanskrit',
  'Sign Languages',
  'Slovak',
  'Slovenian',
  'Spanish',
  'Sardinian',
  'Serbian',
  'Swedish',
  'Tamil',
  'Telugu',
  'Turkish',
  'Ukrainian',
  'Urdu',
  'Vietnamese',
  'Welsh',
  'Walloon',
  'Yiddish',
];
export default wolrdLanguages;
